import * as Yup from 'yup'

import { accountTypeValidationSchema } from 'src/components/organisms/forms/AccountForm/AccountFormFieldSets/validationSchema'

import { AccountType } from 'src/types/account'

import { AccountActionType } from '../AccountForm/types'

const addressSchema = Yup.object({
  StreetNumber: Yup.string().optional().nullable(),
  StreetName: Yup.string().optional().nullable(),
  City: Yup.string().optional().nullable(),
  District: Yup.string().optional().nullable(),
  Region: Yup.string().optional().nullable(),
  Country: Yup.string().optional().nullable(),
  PostalCode: Yup.string().optional().nullable(),
  Place: Yup.string().optional().nullable(),
  Geo: Yup.string().optional().nullable()
})

export const validationSchema = Yup.object({
  ...accountTypeValidationSchema('Type'),
  Type: Yup.string().required('Please select your account type'),
  Name: Yup.string().required('Please enter your name'),
  Description: Yup.string().nullable(),
  ContactFirstname: Yup.string().required(
    'Please enter a value for first name'
  ),
  ContactLastname: Yup.string().required('Please enter a value for last name'),
  Email: Yup.string().email().required('Please enter your email'),
  Mobile: Yup.string().nullable(),
  Phone: Yup.string().nullable(),
  RegionId: Yup.string().nullable(),
  DistrictId: Yup.string().nullable(),
  Address: addressSchema.optional().nullable(),
  ManualAddress: Yup.string(),
  BusinessSize: Yup.string().when('AccountType', {
    is: (accountType: AccountType) => accountType === AccountType.Business,
    then: Yup.string().required('Please select a value for business size'),
    otherwise: Yup.string().optional().nullable()
  }),
  Department: Yup.string().when(['AccountType', 'AccountActionType'], {
    is: (accountType: AccountType, accountActionType: AccountActionType) =>
      accountType === AccountType.Business &&
      accountActionType === AccountActionType.Donate,
    then: Yup.string().required('Please select your department'),
    otherwise: Yup.string().optional().nullable()
  }),
  JobTitle: Yup.string().when(['AccountType', 'AccountActionType'], {
    is: (accountType: AccountType, accountActionType: AccountActionType) =>
      accountType === AccountType.Business &&
      accountActionType === AccountActionType.Donate,
    then: Yup.string().required('Please enter your job title'),
    otherwise: Yup.string().optional().nullable()
  })
})
